import { render } from "./EventDetailAnotherList.vue?vue&type=template&id=3b1e2fad&scoped=true"
import script from "./EventDetailAnotherList.vue?vue&type=script&lang=js"
export * from "./EventDetailAnotherList.vue?vue&type=script&lang=js"

import "./EventDetailAnotherList.vue?vue&type=style&index=0&id=3b1e2fad&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1e2fad"]])

export default __exports__